/** Contrato comum das etapas do wizard Criar envios (§6). */
export interface StepProps {
  planId: string;
  /** A etapa informa ao wizard se o usuário já pode avançar. */
  onReadyChange: (ready: boolean) => void;
  /**
   * A etapa pede ao wizard para ir a outra etapa (0-based). Usado quando um
   * plano que falhou é reiniciado: o operador volta ao Passo 1 para corrigir os
   * produtos em vez de ficar preso na tela de erro.
   */
  onGoToStep?: (step: number) => void;
}

export const STEP_LABELS: readonly string[] = [
  "Selecionar produtos",
  "Método e embalagem",
  "Confirmação de envio",
  "Etiquetas de caixa",
  "Rastreamento"
];
